<template>
  <div class="updateOrderStatus">
    <el-dialog
            title="修改状态"
            :visible="true"
            @close="handleClose"
            width="460px"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="订单状态:">
          <el-select v-model="form.orderStatus" placeholder="请选择" size="small" style="width: 100%;">
            <!--<el-option key="2" label="购买完" value="2"></el-option>-->
            <!--<el-option key="0" label="等待到库" value="0"></el-option>-->
            <!--<el-option key="8" label="检品中" value="8"></el-option>-->
            <!--<el-option key="52" label="已发送" value="52"></el-option>-->
            <el-option v-for="item in orderStatusList" v-if="optional.includes(item.value)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <div style="margin-bottom: 10px;color: red;">注意：此操作只会强制修改订单状态，并不会操作订单相关的费用，如需扣费或者退费，请手动处理！</div>
      </el-form>
      <div class="dialog-footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="onSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "updateOrderStatus",
    data(){
      return{
        form: {
          orderStatus: ''
        },
        orderStatusList:[
          {
            label:'购买完',
            value:'2'
          },
          {
            label:'等待到库',
            value:'0'
          },
          {
            label:'检品中',
            value:'8'
          },
          {
            label:'已发送',
            value:'52'
          },
        ]
      }
    },
    props: {
      id: {
        type: Number,
        default: ()=>(0)
      },
      optional:{
        type: Array,
        default: () => ([])
      }
    },
    methods: {
      async onSave(){
        if (this.form.orderStatus === ''){
          this.$modal.msgError("请选择要修改的状态");
          return;
        }
        this.$confirm("确定要修改状态吗？", {
          confirmButtonText: "确定",
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: "退出",
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        })
          .then(async () => {
            const params = {
              orderStatus: this.form.orderStatus,
              id: this.id
            }
            console.log(params)
            const res = await this.$http.post("order/updateOrderStatus", params);
            if (res.data.code === 200) {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
            }
            // const res = await saveFile(params)
            this.$options.confirm(true)
          })
          .catch(() => {
            /*this.$message({
            type: "info",
            message: "已退出操作"
          });*/
          });



      },
      handleClose() {
        this.$options.cancel('cancel')
      }
    }
  }
</script>

<style scoped lang="less">
.updateOrderStatus{
  .dialog-footer{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
